import { useState, useLayoutEffect } from "react";

function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height, scrollY } = window;
  return {
    width,
    height,
    scrollY,
  };
}

export default function useWindowDimensions() {
  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );

  useLayoutEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return windowDimensions;
}
